<main *ngIf="pageContent">
	<div class="confirm-wrapper" *ngIf="!ibmflag">
		<div class="alert valign-children-middle alertCancel">
			<div class="alert-success" role="img" aria-label="Success">
				<i class="icon-approval"></i>
			</div>
			<div><span [innerHTML]="pageContent.messages.success"></span></div>
			<div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close"></div>
		</div>
		<div>
			<h1><strong>{{pageContent.heading}}</strong></h1>
			<p *ngIf="FANList.length>1||FANList.length==0"> You removed {{FANList.length}} accounts from the device
				management program</p>
			<p *ngIf="FANList.length==1"> You removed {{FANList.length}} account from the device management program</p>
			<p [innerHTML]="pageContent.content_link1"> </p>
		</div>

		<!-- FAN Less than 5 -->
		<app-customgrid [gridOptions]="gridOptions"></app-customgrid>
		<div class="text-right buttons-section">
			<button (click)="backToFirstPage()" class="btn btn-secondary" [innerHTML]="pageContent.back.label"></button>
		</div>
	</div>
	<div class="confirm-wrappermdm" *ngIf="ibmflag">
		<div class="alert valign-children-middle alertCancel">
			<div class="alert-success" role="img" aria-label="Success">
				<i class="icon-approval"></i>
			</div>
			<div><span [innerHTML]="pageContent.messages.success"></span></div>
			<div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close"></div>
		</div>
		<h1>{{pageContent.heading}}</h1>
		<h2> {{pageContent.subhead}}</h2>
		<p *ngIf="FANList.length==1"> {{FANList.length}} foundation account removed. </p>
		<p *ngIf="FANList.length>1||FANList.length==0"> {{FANList.length}} foundation accounts removed. </p>
		<!-- FAN Less than 5 -->
		<app-customgrid [gridOptions]="gridOptions"></app-customgrid>
		<div class="panel panel-header">
			<div class="panel-message">
				<div *ngIf="!enableRouterLink">
					<h3> {{pageContent.somefans.content_head}}</h3>
					<p *ngIf="FANList.length>1||FANList.length==0"> You removed {{FANList.length}} accounts from the
						device management program</p>
					<p *ngIf="FANList.length==1"> You removed {{FANList.length}} account from the device management
						program</p>
					<p [innerHTML]="pageContent.somefans.content_link"> </p>
				</div>

				<div *ngIf="enableRouterLink" class="home-link">
					<div>
						<h3> {{pageContent.allfans.content_head}}</h3>
						<p> {{pageContent.allfans.content_link}}</p>
					</div>
					<p>
						<!-- Commenting out as a part of US-1367 
						 <a href="javascript:void(0)" (click)="navToLearnPage()" class="btn btn-link">
							{{pageContent.links.learn.label}} </a> | -->
						<a href="javascript:void(0)" (click)="navToHomePage()" class="btn btn-link">
							{{pageContent.links.home.label}} </a>
					</p>
				</div>
			</div>
		</div>
		<div *ngIf="!enableRouterLink">
			<div class="text-right buttons-section">
				<button (click)="backToCallingPage()" class="btn btn-secondary"
					[innerHTML]="pageContent.links.back.label"></button>
			</div>
		</div>
	</div>
</main>